export default __webpack_public_path__ + "static/graph_vertical-73218e1a1a0c93fb0f1dd1d2f801fc90.svg";